import "./Catalog.module.css";
import Intestazione from "@/reusable_sections/Header";
import ISegretiDellaTradizione from "./sections/ISegretiDellaTradizione";
import ISegretiDellaTradizioneCopy from "./sections/ISegretiDellaTradizioneCopy";
import TuttiINostriDolci from "./sections/TuttiINostriDolci";
import PieDiPagina from "@/reusable_sections/Footer";
export default function CatalogPage() {
  return <div>
      <Intestazione />
      <ISegretiDellaTradizione />
      <ISegretiDellaTradizioneCopy />
      <TuttiINostriDolci />
      <PieDiPagina />
    </div>;
}